export default __webpack_public_path__ + "static/media/cross.2f0dd0f2.svg";